<template>

  <div class="oc-list-toolbar mb-50">

    <!-- Actions + optional subtitle (page title is Offer Configure in nav) -->

    <div class="oc-list-toolbar__top d-flex flex-wrap justify-content-between align-items-center mb-50">

      <p class="text-muted small mb-0 oc-list-toolbar__subtitle d-none d-md-block">

        Manage letter content, salary tables, and branding per site &amp; role.

      </p>

      <div class="d-flex flex-wrap align-items-center oc-list-toolbar__actions ml-md-auto">

        <b-button

          v-if="canManage"

          variant="outline-primary"

          size="sm"

          class="btn-icon oc-icon-btn oc-touch-btn mr-50 mb-25 mb-md-0"

          title="New Template"

          aria-label="New Template"

          @click="$emit('create')"

        >

          <feather-icon icon="PlusIcon" size="14" />

        </b-button>

        <b-button

          variant="outline-secondary"

          size="sm"

          class="btn-icon oc-icon-btn oc-touch-btn mb-25 mb-md-0"

          :disabled="loading"

          title="Refresh"

          aria-label="Refresh"

          @click="$emit('refresh')"

        >

          <b-spinner v-if="loading" small />

          <feather-icon v-else icon="RefreshCwIcon" size="14" />

        </b-button>

      </div>

    </div>



    <!-- Filters -->

    <b-card class="oc-list-toolbar__filters mb-50" border-variant="light" body-class="p-50">

      <b-row class="align-items-end no-gutters">

        <b-col cols="12" md="8" lg="9" class="pr-md-50 mb-50 mb-md-0">

          <label class="oc-filter-label" for="oc-search-input">Search</label>

          <b-input-group size="sm">

            <b-input-group-prepend is-text class="oc-search-prepend">

              <feather-icon icon="SearchIcon" size="14" />

            </b-input-group-prepend>

            <b-form-input

              id="oc-search-input"

              :value="searchQuery"

              size="sm"

              placeholder="Site name, client, or job title…"

              @input="$emit('update:searchQuery', $event)"

            />

            <b-input-group-append v-if="searchQuery">

              <b-button variant="outline-secondary" size="sm" class="oc-touch-btn" @click="$emit('update:searchQuery', '')">

                <feather-icon icon="XIcon" size="13" />

              </b-button>

            </b-input-group-append>

          </b-input-group>

        </b-col>

        <b-col cols="12" md="4" lg="3" class="pl-md-50 d-flex align-items-end justify-content-md-end">

          <b-form-checkbox

            :checked="showInactive"

            switch

            size="sm"

            class="mb-0 oc-inactive-switch"

            @change="$emit('show-inactive-change', $event)"

          >

            {{ showInactive ? 'Inactive' : 'Active' }}

          </b-form-checkbox>

        </b-col>

      </b-row>

    </b-card>



    <!-- Stats pills -->

    <div v-if="!loading && totalCount" class="oc-list-toolbar__stats d-flex flex-wrap align-items-center">

      <span class="oc-stat-pill oc-stat-pill--primary mr-50 mb-25">

        <feather-icon icon="LayersIcon" size="12" class="mr-25" />

        <strong>{{ filteredCount }}</strong>

        <span class="oc-stat-pill__label">shown</span>

      </span>

      <span v-if="activeCount || !showInactive" class="oc-stat-pill oc-stat-pill--success mr-50 mb-25">

        <feather-icon icon="CheckCircleIcon" size="12" class="mr-25" />

        <strong>{{ activeCount }}</strong>

        <span class="oc-stat-pill__label">active</span>

      </span>

      <span v-if="inactiveCount || showInactive" class="oc-stat-pill oc-stat-pill--muted mb-25">

        <feather-icon icon="MinusCircleIcon" size="12" class="mr-25" />

        <strong>{{ inactiveCount }}</strong>

        <span class="oc-stat-pill__label">inactive</span>

      </span>

    </div>

  </div>

</template>



<script>

import {

  BCard,

  BButton,

  BRow,

  BCol,

  BFormInput,

  BFormCheckbox,

  BInputGroup,

  BInputGroupPrepend,

  BInputGroupAppend,

  BSpinner,

} from 'bootstrap-vue'



export default {

  name: 'OfferConfigureListToolbar',

  components: {

    BCard,

    BButton,

    BRow,

    BCol,

    BFormInput,

    BFormCheckbox,

    BInputGroup,

    BInputGroupPrepend,

    BInputGroupAppend,

    BSpinner,

  },

  props: {

    canManage: { type: Boolean, default: false },

    loading: { type: Boolean, default: false },

    searchQuery: { type: String, default: '' },

    showInactive: { type: Boolean, default: false },

    totalCount: { type: Number, default: 0 },

    filteredCount: { type: Number, default: 0 },

    activeCount: { type: Number, default: 0 },

    inactiveCount: { type: Number, default: 0 },

  },

}

</script>



<style scoped>

.oc-list-toolbar {

  position: sticky;

  top: 0;

  z-index: 10;

  padding: 0.5rem 0 0.35rem;

  margin-bottom: 0.25rem;

  background: #f8f8f8;

}



.oc-list-toolbar__subtitle {

  max-width: 28rem;

  line-height: 1.35;

  font-size: 0.8125rem;

}



.oc-list-toolbar__filters {

  background: #f8f9fb;

  border-radius: 0.35rem;

  border: 1px solid #eef0f3 !important;

  box-shadow: none !important;

}



.oc-filter-label {

  display: block;

  font-size: 0.625rem;

  font-weight: 700;

  text-transform: uppercase;

  letter-spacing: 0.04em;

  color: #6e6b7b;

  margin-bottom: 0.2rem;

}



.oc-search-prepend {

  background: #fff;

  border-color: #d8d6de;

}



.oc-stat-pill {

  display: inline-flex;

  align-items: center;

  font-size: 0.75rem;

  padding: 0.15rem 0.5rem;

  border-radius: 0.25rem;

  background: #f3f4f6;

  border: none;

  box-shadow: none;

  color: #5e5873;

}



.oc-stat-pill strong {

  font-weight: 700;

  margin-right: 0.15rem;

}



.oc-stat-pill__label {

  opacity: 0.75;

  font-size: 0.6875rem;

}



.oc-stat-pill--primary {

  background: rgba(0, 186, 176, 0.1);

  color: #0f766e;

}



.oc-stat-pill--success {

  background: rgba(40, 199, 111, 0.1);

  color: #1a8754;

}



.oc-stat-pill--muted {

  background: #f3f4f6;

  color: #6b7280;

}



.oc-touch-btn {

  min-height: 2rem;

}



.oc-list-toolbar__actions .oc-icon-btn.btn-icon {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  min-width: 2rem;

  padding: 0.4rem;

  line-height: 1;

}



.oc-inactive-switch >>> .custom-control-label {

  font-size: 0.8125rem;

  font-weight: 500;

  padding-top: 0.1rem;

}



@media (max-width: 991.98px) {

  .oc-list-toolbar {

    padding-top: 0.35rem;

  }



  .oc-list-toolbar__actions {

    width: 100%;

    justify-content: flex-end;

  }

}

</style>


